var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 64,
    viewBox: "0 0 30 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_5043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6041 7.13325C17.9061 3.94632 15.5829 0.709589 15.1082 0.0373468C15.0583 -0.0124489 14.9833 -0.0124489 14.9334 0.0373468C14.4587 0.709589 12.1355 3.94632 9.43752 7.13325C-13.7199 36.5376 13.0848 56.3813 13.0848 56.3813L13.3096 56.5306C13.5094 59.5932 14.009 64 14.009 64H15.0083H16.0075C16.0075 64 16.5072 59.618 16.707 56.5306L16.9318 56.3565C16.9568 56.3565 43.7614 36.5376 20.6041 7.13325ZM15.0083 55.933C15.0083 55.933 13.8092 54.9123 13.4845 54.3893V54.3397L14.9334 22.3209C14.9334 22.2213 15.0833 22.2213 15.0833 22.3209L16.5321 54.3397V54.3893C16.2074 54.9123 15.0083 55.933 15.0083 55.933Z",
    fill: "#00684A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_5043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.7674,
    height: 64,
    fill: "white",
    transform: "translate(0.0126953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMongodb);
export default __webpack_public_path__ + "static/media/icon-mongodb.1f537e094ed8229e1c76b337efa849f6.svg";
export { ForwardRef as ReactComponent };